import React, { useState } from "react";
import "./styles.css";

const hehe = 180;

const hour = new Date().getHours();
const minute = new Date().getMinutes();
const second = new Date().getSeconds();

export default function App() {
  setInterval(updateSeconds, 1000);
  setInterval(updateMinutes, 1000);
  setInterval(updateHours, 1000);
  let [secondC, setSecond] = useState(0);
  let [minuteC, setMinute] = useState(0);
  let [hourC, setHour] = useState(0);

  function updateSeconds() {
    let newSec = new Date().getSeconds();
    setSecond(newSec * 6);
  }

  function updateMinutes() {
    let newMinute = new Date().getMinutes();
    setMinute(newMinute * 6);
  }

  function updateHours() {
    let newHour = new Date().getUTCHours();
    setHour(newHour * 15);
  }

  return (
    <div>
      <div className="container">
        <div
          className="minute"
          style={{ transform: `rotate(${minuteC}deg)` }}
        ></div>
        <img
          src={"https://media-public.canva.com/IFit8/MAEuHDIFit8/1/tl.png"}
          className="second"
          style={{ transform: `rotate(${secondC}deg)` }}
        ></img>
        <div
          className="hour"
          style={{ transform: `rotate(${hourC}deg)` }}
        ></div>

        <div className="point"></div>
      </div>
      <h1>Analog Clock</h1>
      <h3>Made by Getu2</h3>
    </div>
  );
}
